export default __webpack_public_path__ + "static/media/ArrowDownBtn.0ce2bf11.svg";